<template>
    <paged-contact-core :catId="catId" :hideAddNew="hideAddNew" :apiClient="apiClient" v-on:onselect="onSelect" :skipAddress="skipAddress"></paged-contact-core>
</template>
<script>
    import PagedContactCore from './PagedContactCore.vue';

    export default {
        components: {
            PagedContactCore
        },
        props: ["catId", "hideAddNew","skipAddress"],
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.contactsApiClient;
            }
        },
        methods: {
            onSelect: function (contact) {
                this.$emit('onselect', contact);
            }
        },
        created: function () {

        }        
    }
</script>